import * as t from "io-ts";
import { MaybeExportedTreeV } from "./tree";

export const GlobalBlockSettingsV = t.type({
  preview: t.partial({
    acfFlexibleField: t.string,
    acfFlexibleFieldRow: t.number
  })
});

export const GlobalBlockV = t.intersection([
  t.type({
    label: t.string,
    id: t.number, // can be -1 when creating a new post
    tree: MaybeExportedTreeV,
    editInBreakdanceLink: t.string
  }),
  t.partial({
    settings: t.union([GlobalBlockSettingsV, t.literal(false)]),
    status: t.union([t.literal("publish"), t.literal("trash")])
  })
]);

export type GlobalBlock = t.TypeOf<typeof GlobalBlockV>;

export const GlobalBlocksV = t.array(GlobalBlockV);
